// import dependencies
import React, { useEffect, useState } from "react";
import Popover from "react-popover";

// assets and scss import
import "./collectionDetailsTableView.scss";
import NoDataFound from "../../../../assets/Nodata.svg";

// project file imprt
import FooterPagination from "../../../common/FooterPagination";
// constants import
import { COLLECTION_DETAILS_TABLE_HEADER } from "../../constants";
import moment from "moment";
import { formatDecimalNumber } from "../../../../Util/Helper/formatNumberWithDecimals";

const CollectionDetailsTableView = ({
  headingFlag = true,
  showFlag,
  totalRecords,
  setShowFlag,
  collectionDetails,
  currentPage,
  onPageChange,
}) => {
  const [popoverId, setPopoverId] = useState("");

  const handleSeeAll = () => {
    setShowFlag(false);
  };

  const handlePopoverOpen = (id) => {
    setPopoverId(id);
  };
  const handlePopoverClose = () => {
    setPopoverId("");
  };

  const displayHoverContent = (msg) => {
    return <div className="cdtvc-msg-popover">{msg}</div>;
  };

  const displayHyphen = () => {
    return <span className="cdtv-hypen">-</span>;
  };

  const displayListContent = (arr) => {
    return (
      <div className="cdtvc-list-popover">
        <ul>
          {arr?.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </div>
    );
  };

  const displayPaymentMethods = (arr) => {
    return (
      <div className="cdtvc-list-popover">
        <ul>
          {arr?.map((item, index) => (
            <li key={index}>
              {item !== "Cash" && item !== "C2C Online"
                ? `Others/${item}`
                : item}
            </li>
          ))}
        </ul>
      </div>
    );
  };
  const collectionDetailsTableUI = () => {
    let collectainDetailsList = showFlag
      ? collectionDetails?.slice(0, 5)
      : collectionDetails;
    return (
      <>
        <table className="cdtvc-table">
          <thead>
            <tr>
              {COLLECTION_DETAILS_TABLE_HEADER.map((details) => (
                <th key={details?.id} className={details?.className}>
                  {details?.title}
                </th>
              ))}
            </tr>
          </thead>
          {collectainDetailsList?.length > 0 && (
            <tbody>
              {collectainDetailsList.map((content, index) => (
                <tr key={index}>
                  <td>{content?.user_full_name}</td>
                  <td>
                    {content?.appointment_date
                      ? moment(content?.appointment_date)?.format("DD/MM/YYYY")
                      : ""}
                  </td>
                  <td>
                    <p className="cdtvc-patient-phone-uhid">
                      <span>{content?.patient_phone}</span>
                      {content?.formatted_uhid && (
                        <span>
                          {" "}
                          | UHID:
                          {content.formatted_uhid.length > 9 ? (
                            <>
                              {`${content.formatted_uhid.slice(0, 9)}`}
                              <Popover
                                isOpen={
                                  popoverId === `uhid-${index}` ? true : false
                                }
                                preferPlace={`below`}
                                place={null}
                                body={displayHoverContent(
                                  content.formatted_uhid
                                )}
                              >
                                <span
                                  className="cdtvc-cursor-pointer"
                                  onMouseOver={() => {
                                    handlePopoverOpen(`uhid-${index}`);
                                  }}
                                  onMouseOut={handlePopoverClose}
                                >
                                  ...
                                </span>
                              </Popover>
                            </>
                          ) : (
                            content.formatted_uhid
                          )}
                        </span>
                      )}
                    </p>
                    <p className="cdtvc-patient-name">
                      {content?.patient_name}
                    </p>
                  </td>
                  <td>
                    {content?.doctor_resources.length ? (
                      <>
                        {content?.doctor_resources
                          ?.slice(0, 2)
                          ?.map((item, index) => (
                            <span key={index}>
                              {item}
                              {content.doctor_resources.length > 1 && (
                                <span>,</span>
                              )}
                            </span>
                          ))}

                        {content?.doctor_resources?.length > 2 && (
                          <Popover
                            isOpen={
                              popoverId === `resname-${index}` ? true : false
                            }
                            preferPlace={`below`}
                            place={null}
                            body={displayListContent(
                              content?.doctor_resources?.slice(2)
                            )}
                          >
                            <span
                              className="cdtvc-cursor-pointer cdtvc-number"
                              onMouseOver={() => {
                                handlePopoverOpen(`resname-${index}`);
                              }}
                              onMouseOut={handlePopoverClose}
                            >
                              +{content?.doctor_resources?.slice(2)?.length}
                            </span>
                          </Popover>
                        )}
                      </>
                    ) : (
                      <>{content?.doctor_name}</>
                    )}
                  </td>
                  <td>
                    {content?.transaction_ids?.length > 0 ? (
                      <>
                        {content?.transaction_ids
                          ?.slice(0, 1)
                          ?.map((item, transIndex) => (
                            <span key={transIndex}>
                              {/* {item} */}
                              {item?.length > 10 ? (
                                <>
                                  {`${item?.slice(0, 10)}`}
                                  <Popover
                                    isOpen={
                                      popoverId === `complete-trans-${index}`
                                        ? true
                                        : false
                                    }
                                    preferPlace={`below`}
                                    place={null}
                                    body={displayHoverContent(item)}
                                  >
                                    <span
                                      className="cdtvc-cursor-pointer"
                                      onMouseOver={() => {
                                        handlePopoverOpen(
                                          `complete-trans-${index}`
                                        );
                                      }}
                                      onMouseOut={handlePopoverClose}
                                    >
                                      ...
                                    </span>
                                  </Popover>
                                </>
                              ) : (
                                item
                              )}
                            </span>
                          ))}

                        {content?.transaction_ids?.slice(1)?.length > 0 && (
                          <Popover
                            isOpen={
                              popoverId === `trans-${index}` ? true : false
                            }
                            preferPlace={`below`}
                            place={null}
                            body={displayListContent(
                              content?.transaction_ids?.slice(1)
                            )}
                          >
                            <span
                              className="cdtvc-cursor-pointer cdtvc-number"
                              onMouseOver={() => {
                                handlePopoverOpen(`trans-${index}`);
                              }}
                              onMouseOut={handlePopoverClose}
                            >
                              +{content?.transaction_ids?.slice(1)?.length}
                            </span>
                          </Popover>
                        )}
                      </>
                    ) : (
                      displayHyphen()
                    )}
                  </td>
                  <td>
                    {" "}
                    {content?.payment_methods?.length > 0 ? (
                      <>
                        {content?.payment_methods
                          ?.slice(0, 1)
                          ?.map((item, index) => (
                            <span key={index}>
                              {item !== "Cash" && item !== "C2C Online"
                                ? `Others/${item}`
                                : item}
                            </span>
                          ))}

                        {content?.payment_methods?.slice(1)?.length > 0 && (
                          <Popover
                            isOpen={
                              popoverId === `payment-${index}` ? true : false
                            }
                            preferPlace={`below`}
                            place={null}
                            body={displayPaymentMethods(
                              content?.payment_methods?.slice(1)
                            )}
                          >
                            <span
                              className="cdtvc-cursor-pointer cdtvc-number"
                              onMouseOver={() => {
                                handlePopoverOpen(`payment-${index}`);
                              }}
                              onMouseOut={handlePopoverClose}
                            >
                              +{content?.payment_methods?.slice(1)?.length}
                            </span>
                          </Popover>
                        )}
                      </>
                    ) : (
                      displayHyphen()
                    )}
                  </td>
                  <td>
                    {content?.amount
                      ? `₹${formatDecimalNumber(content?.amount)}`
                      : displayHyphen()}
                  </td>
                  <td>
                    {content?.receipt_number
                      ? content?.receipt_number
                      : displayHyphen()}
                  </td>
                </tr>
              ))}
            </tbody>
          )}
        </table>
        {collectainDetailsList?.length === 0 && (
          <div className="cdtvc-table-no-data">{displayNoDataFound()}</div>
        )}
        {!showFlag && collectainDetailsList?.length > 0 && footerUI()}
      </>
    );
  };
  const collectionDetailsTableMobileUI = () => {
    let collectainDetailsList = showFlag
      ? collectionDetails?.slice(0, 5)
      : collectionDetails;
    return (
      <>
        <div className="cdtvc-table-mui">
          {collectainDetailsList.map((content, index) => (
            <div key={index} className="cdtvc-table-mui-box">
              <div>
                <p className="cdtvc-mui-label">User Name</p>
                <p className="cdtvc-mui-value">{content?.user_full_name}</p>
              </div>
              <div>
                <p className="cdtvc-mui-label">Appointment</p>
                <p className="cdtvc-mui-value">
                  {content?.appointment_date
                    ? moment(content?.appointment_date)?.format("DD/MM/YYYY")
                    : ""}
                </p>
              </div>
              <div className="cdtvc-mui-patient-details">
                <p className="cdtvc-mui-label">Patient Details</p>
                <p className="cdtvc-mui-value">
                  {" "}
                  <span>{content?.patient_phone}</span>
                  {content?.formatted_uhid && (
                    <span>
                      {" "}
                      | UHID:
                      {content?.formatted_uhid?.length > 10 ? (
                        <>
                          {`${content?.formatted_uhid?.slice(0, 10)}`}
                          <Popover
                            isOpen={
                              popoverId === `uhid-${index}` ? true : false
                            }
                            preferPlace={`below`}
                            place={null}
                            body={displayHoverContent(content?.formatted_uhid)}
                          >
                            <span
                              className="cdtvc-cursor-pointer"
                              onMouseOver={() => {
                                handlePopoverOpen(`uhid-${index}`);
                              }}
                              onMouseOut={handlePopoverClose}
                            >
                              ...
                            </span>
                          </Popover>
                        </>
                      ) : (
                        content?.formatted_uhid
                      )}
                    </span>
                  )}
                  <p>{content?.patient_name}</p>
                </p>
              </div>
              <div className="cdtvc-mui-resoure-name">
                <p className="cdtvc-mui-label">Doctor / Resource Name</p>
                <p className="cdtvc-mui-value">
                  {" "}
                  {content?.doctor_resources?.length > 0 ? (
                    <>
                      {content?.doctor_resources
                        ?.slice(0, 2)
                        ?.map((item, index) => (
                          <span key={index}>
                            {item}
                            {content.doctor_resources.length > 1 && (
                              <span>,</span>
                            )}
                          </span>
                        ))}

                      {content?.doctor_resources?.length > 2 && (
                        <Popover
                          isOpen={
                            popoverId === `resname-${index}` ? true : false
                          }
                          preferPlace={`below`}
                          place={null}
                          body={displayListContent(
                            content?.doctor_resources?.slice(2)
                          )}
                        >
                          <span
                            className="cdtvc-cursor-pointer cdtvc-number"
                            onMouseOver={() => {
                              handlePopoverOpen(`resname-${index}`);
                            }}
                            onMouseOut={handlePopoverClose}
                          >
                            +{content?.doctor_resources?.slice(2)?.length}
                          </span>
                        </Popover>
                      )}
                    </>
                  ) : (
                    <>{content.doctor_name}</>
                  )}
                </p>
              </div>
              <div>
                <p className="cdtvc-mui-label">Transaction Id</p>
                <p className="cdtvc-mui-value">
                  {" "}
                  {content?.transaction_ids?.length > 0 ? (
                    <>
                      {content?.transaction_ids
                        ?.slice(0, 1)
                        ?.map((item, transIndex) => (
                          <span key={transIndex}>
                            {/* {item} */}

                            {item?.length > 10 ? (
                              <>
                                {`${item?.slice(0, 10)}`}
                                <Popover
                                  isOpen={
                                    popoverId === `complete-trans-${index}`
                                      ? true
                                      : false
                                  }
                                  preferPlace={`below`}
                                  place={null}
                                  body={displayHoverContent(item)}
                                >
                                  <span
                                    className="cdtvc-cursor-pointer"
                                    onMouseOver={() => {
                                      handlePopoverOpen(
                                        `complete-trans-${index}`
                                      );
                                    }}
                                    onMouseOut={handlePopoverClose}
                                  >
                                    ...
                                  </span>
                                </Popover>
                              </>
                            ) : (
                              item
                            )}
                          </span>
                        ))}

                      {content?.transaction_ids?.slice(1)?.length > 0 && (
                        <Popover
                          isOpen={popoverId === `trans-${index}` ? true : false}
                          preferPlace={`below`}
                          place={null}
                          body={displayListContent(
                            content.transaction_ids.slice(1)
                          )}
                        >
                          <span
                            className="cdtvc-cursor-pointer cdtvc-number"
                            onMouseOver={() => {
                              handlePopoverOpen(`trans-${index}`);
                            }}
                            onMouseOut={handlePopoverClose}
                          >
                            +{content.transaction_ids.slice(1).length}
                          </span>
                        </Popover>
                      )}
                    </>
                  ) : (
                    displayHyphen()
                  )}
                </p>
              </div>
              <div>
                <p className="cdtvc-mui-label">Payment Method</p>
                <p className="cdtvc-mui-value">
                  {" "}
                  {content?.payment_methods?.length > 0 ? (
                    <>
                      {content?.payment_methods
                        ?.slice(0, 1)
                        ?.map((item, index) => (
                          <span key={index}>{item} </span>
                        ))}

                      {content?.payment_methods?.slice(1)?.length > 0 && (
                        <Popover
                          isOpen={
                            popoverId === `payment-${index}` ? true : false
                          }
                          preferPlace={`below`}
                          place={null}
                          body={displayListContent(
                            content?.payment_methods?.slice(1)
                          )}
                        >
                          <span
                            className="cdtvc-cursor-pointer cdtvc-number"
                            onMouseOver={() => {
                              handlePopoverOpen(`payment-${index}`);
                            }}
                            onMouseOut={handlePopoverClose}
                          >
                            +{content?.payment_methods?.slice(1)?.length}
                          </span>
                        </Popover>
                      )}
                    </>
                  ) : (
                    displayHyphen()
                  )}
                </p>
              </div>
              <div>
                <p className="cdtvc-mui-label">Receipt Amount</p>
                <p className="cdtvc-mui-value">
                  {content?.amount
                    ? `₹${formatDecimalNumber(content?.amount)}`
                    : displayHyphen()}
                </p>
              </div>
              <div>
                <p className="cdtvc-mui-label">Receipt Number</p>
                <p className="cdtvc-mui-value">
                  {content?.receipt_number
                    ? content?.receipt_number
                    : displayHyphen()}
                </p>
              </div>
            </div>
          ))}
        </div>
        {!showFlag && footerUI()}
      </>
    );
  };

  const footerUI = () => {
    return (
      <div className="cdtvc-footer">
        <FooterPagination
          currentPage={currentPage}
          totalCount={totalRecords}
          pageSize={10}
          onPageChange={onPageChange}
        />
      </div>
    );
  };
  const showAllButtonUI = () => {
    return (
      <div className="cdtvc-show-all-button-container">
        <button className="cdtvc-show-all-button" onClick={handleSeeAll}>
          See all
        </button>
      </div>
    );
  };

  const displayNoDataFound = () => {
    return (
      <div className="cdtvc-no-data-found">
        <div>
          <img src={NoDataFound} alt="noData" className="no-data" />
        </div>
        <div style={{ marginTop: 15 }}>
          <span
            style={{
              fontWeight: "bold",
              fontSize: 15,
              color: "#1B2027",
              textAlign: "center",
            }}
          >
            No Record Found
          </span>
        </div>
        <span style={{ fontSize: 12, color: "#707070", textAlign: "center" }}>
          There are no appointments available
        </span>
      </div>
    );
  };

  return (
    <div className="collection-details-table-view-container">
      {headingFlag && <h2>Collection Details</h2>}

      {window.innerWidth > 768 ? (
        <>{collectionDetailsTableUI()}</>
      ) : (
        <>
          {collectionDetails?.length > 0 ? (
            collectionDetailsTableMobileUI()
          ) : (
            <div className="cdtvc-table-no-data">{displayNoDataFound()}</div>
          )}
        </>
      )}

      {showFlag && collectionDetails?.length > 0 && showAllButtonUI()}
    </div>
  );
};

export default CollectionDetailsTableView;
